import { legendActions } from '@bvt-features/tenant-suitability/store/legend/legend.slice';
import { useDispatch, useSelector } from 'react-redux';

export const useLegend = () => {
  const state = useSelector((state) => state.features.TENANT_SUITABILITY.legend);
  const dispatch = useDispatch();

  const resetState = () => dispatch(legendActions.resetState());
  const setItems = (items) => dispatch(legendActions.setItems(items));

  return {
    resetState,
    setItems,
    state,
  };
};
